import React from 'react';

const SurvivalToRest: React.FC = () => {
  return (
    <section className="py-24 md:py-32 bg-liza-bg relative overflow-hidden">
      {/* Decorative blobs */}
      <div className="absolute top-20 left-[-10%] w-96 h-96 bg-accent-light/30 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-20 right-[-10%] w-96 h-96 bg-accent-light/30 rounded-full blur-3xl pointer-events-none"></div>

      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10">
        
        {/* Main Header */}
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-primary leading-tight font-normal">
            Van overleven naar rust, <br className="hidden sm:inline" /> 
            <span className="italic font-normal text-primary/90">energie en regie</span>
          </h2>
          <p className="text-base md:text-lg text-gray-500 font-light mt-6 max-w-2xl mx-auto leading-relaxed">
            Je hoeft niet nog verder vast te lopen om herstel te verdienen.
          </p>
          <p className="text-base md:text-lg text-primary/80 font-light mt-4 max-w-2xl mx-auto leading-relaxed italic">
            In mijn begeleiding werk je aan herstel van lichaam én brein, zodat je weer grip krijgt op je energie en belastbaarheid.
          </p>
        </div>

        {/* Two Columns / Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-stretch">
          
          {/* Card 1: Herkenning */}
          <div className="bg-white rounded-[2.5rem] border border-accent-light/70 shadow-[0_15px_40px_-15px_rgba(217,192,171,0.15)] p-8 md:p-12 flex flex-col justify-between hover:shadow-xl transition-all duration-500 relative group">
            <div>
              {/* Badge */}
              <span className="text-accent font-bold tracking-[0.25em] text-[10px] uppercase block mb-4">
                Herkenning
              </span>
              
              {/* Card Title */}
              <h3 className="text-2xl md:text-3xl font-serif text-primary italic leading-snug mb-8 font-normal">
                Misschien herken je jezelf hierin:
              </h3>

              {/* Bullet List */}
              <ul className="space-y-4">
                {[
                  "Je staat de hele dag “aan”, zelfs als je thuis bent",
                  "Je bent snel moe, maar slapen helpt nauwelijks",
                  "Je hoofd blijft doorgaan, ook ’s avonds",
                  "Kleine dingen voelen al snel te veel",
                  "Je werk kost steeds meer energie",
                  "Je voelt dat je niet meer goed herstelt"
                ].map((symptom, idx) => (
                  <li key={idx} className="flex items-start gap-4">
                    <span className="w-1.5 h-1.5 rounded-full bg-accent/70 mt-[9px] shrink-0 group-hover:bg-accent transition-colors"></span>
                    <span className="text-gray-600 font-light text-[15px] leading-relaxed">
                      {symptom}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Bottom Accentuated Quote */}
            <div className="mt-10 pt-8 border-t border-accent/10">
              <p className="text-primary font-serif italic text-base md:text-[17px] leading-relaxed">
                Je probeert door te gaan, maar merkt dat het niet meer vanzelf gaat.
              </p>
            </div>
          </div>

          {/* Card 2: Wat je terug kunt krijgen */}
          <div className="bg-white rounded-[2.5rem] border border-accent-light/70 shadow-[0_15px_40px_-15px_rgba(217,192,171,0.15)] p-8 md:p-12 flex flex-col justify-between hover:shadow-xl transition-all duration-500 relative group">
            <div>
              {/* Badge */}
              <span className="text-accent font-bold tracking-[0.25em] text-[10px] uppercase block mb-4">
                Wat je terug kunt krijgen
              </span>
              
              {/* Card Title */}
              <h3 className="text-2xl md:text-3xl font-serif text-primary italic leading-snug mb-8 font-normal">
                Wat veel mensen weer ervaren:
              </h3>

              {/* Checkmarks List */}
              <ul className="space-y-4">
                {[
                  "meer rust in je hoofd",
                  "beter slapen en herstellen",
                  "meer energie over de dag",
                  "beter grenzen voelen en bewaken",
                  "weer vertrouwen in je eigen lichaam",
                  "duurzaam herstel, niet alleen tijdelijk oplappen"
                ].map((benefit, idx) => (
                  <li key={idx} className="flex items-start gap-3.5">
                    {/* Elegant custom check circle */}
                    <div className="w-5 h-5 rounded-full bg-[#FAF7F2] border border-accent/40 flex items-center justify-center text-primary shrink-0 mt-[4px] group-hover:border-accent group-hover:bg-accent-light/20 transition-all">
                      <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-gray-600 font-light text-[15px] leading-relaxed">
                      {benefit}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
            
            {/* Bottom Accentuated Quote */}
            <div className="mt-10 pt-8 border-t border-accent/10">
              <p className="text-primary font-serif italic text-base md:text-[17px] leading-relaxed">
                Je zet de stap van overleven naar écht leven, met rust en hernieuwde energie.
              </p>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default SurvivalToRest;
